/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_PolicyInputs */

const en_case_payment_validation_policy = /** @type {(inputs: Case_Payment_Validation_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This payment method is not enabled in the current client policy.`)
};

const pt_br2_case_payment_validation_policy = /** @type {(inputs: Case_Payment_Validation_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta forma de pagamento não está habilitada na política atual do cliente.`)
};

/**
* | output |
* | --- |
* | "This payment method is not enabled in the current client policy." |
*
* @param {Case_Payment_Validation_PolicyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_policy = /** @type {((inputs?: Case_Payment_Validation_PolicyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_PolicyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_policy(inputs)
	return pt_br2_case_payment_validation_policy(inputs)
});